import React, { Component } from 'react'

class Sounds extends Component {
  componentDidMount() {
    window.title = "Sounds"
  }
  render () {
    return (
      <section className="container fadeInUp photo">
          <div className="" style={{ width: "100%"}}>
            <h1>{ROOT_DATA.generalInfo.name}'s Sounds</h1>
            <iframe width="100%" height="450" scrolling="no" frameBorder="no" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/playlists/359803432&amp;color=%23c1a35a&amp;auto_play=false&amp;hide_related=false&amp;show_comments=true&amp;show_user=true&amp;show_reposts=false&amp;show_teaser=true"></iframe>
          </div>
        </section>
    )
  }
}

export default Sounds


// WEBPACK FOOTER //
// src/javascripts/pages/Sounds.js